import { render, staticRenderFns } from "./AdditionalMailRecipients.vue?vue&type=template&id=1598bc22"
import script from "./AdditionalMailRecipients.vue?vue&type=script&lang=js"
export * from "./AdditionalMailRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports